<form clrForm clrLayout="vertical">
  <clr-toggle-container>
    <clr-toggle-wrapper>
      <input type="checkbox" clrToggle [(ngModel)]="selectedValue" name="options" (change)="toggleChanged($event)"/>
      <label>{{toggleConfig.Label}}</label>
    </clr-toggle-wrapper>
  </clr-toggle-container>
</form>
